import _station from '../../../../../../../../_station'
import store from '../../../../../store'
import('./list_item.css')

export default function ListItem(opts){
    BaseConstructor.call(this)
    let station = opts.station
    let container = opts.container
    let chart_name = opts.chart_name
    let elements = {}
    let context = this

    this.generate = () =>{
        buildContainer()
        generateIcon()

        // estações flu atuais (foram a base para a consulta de postos próximos)
        let flu_stations_ids = getCurrentIds('flu')
        // flu_stations_ids = flu_stations_ids.map(Number)

        let flu_stations = _station.getStationById(flu_stations_ids)
        
        $(elements.container).append(
            `<div>${station.prefix}</div>`, 
            `<div>${station.date_last_measurement}</div>`,
            `${flu_stations.map(x=> `<div><div class="font-size-xs">${x.prefix}</div><div class='font-weight-bold'>${station[x.prefix].toFixed(2)} km</div></div>`).join('')}`
        )

        $(container).append(elements.container)

        this.update()

        eventsHandler()
    }

    this.update = () =>{
        let plus_ids = getCurrentIds('plu')
        
        //verificando se esta selecionada no momento
        $(elements.container).toggleClass('selected', plus_ids.includes(station.id))
    }

    function generateIcon(){
        let el = context.createElement('i', 'fas fa-check-circle chart-list-stations-plu-list-item-icon')
        // $(el).html('Icone')
        $(elements.container).append(el)
    }

    function buildContainer(){
        elements.container = context.createElement('div', 'chart-list-stations-plu-list-item-container flex flex-v-center')
        $(elements.container).css({
            'display': 'flex',
            'justify-content': 'space-between'
        })
    }

    function eventsHandler(){
        $(elements.container).on('click', () =>{
            let current_plus = getCurrentIds('plu')
            current_plus = _.xor(current_plus, [station.id])
            context.trigger('click', context)

            store.setChartNestedProp(chart_name, 'stations_list.plu.ids', current_plus)


            context.update()
        })
    }

    function getCurrentIds(type){
        let id = store.getChartNestedProp(chart_name, `stations_list.${type}.ids`) || []
        return id.map(Number)
    }
}

ListItem.prototype = Object.create(BaseConstructor.prototype)